import { useState, useEffect } from 'react';
import type { MenuProps } from 'antd';
import { Menu } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '@/stores';
import { useNavigate, Outlet } from 'react-router-dom';
import HeadContent from '@/components/HeadContent/HeadContent';
import RouteGuide from '@/components/RouteGuide/RouteGuide';
import { MenuApiItem } from '@/interface/menu';
import Https from '@/https/index';
import {
  HomeOutlined,
  AppstoreOutlined,
  ContainerOutlined,
  DesktopOutlined,
  MailOutlined,
  MenuFoldOutlined,
  PieChartOutlined,
} from '@ant-design/icons';
import './Main.css'

type MenuItem = Required<MenuProps>['items'][number];

const IconList = [
  <HomeOutlined />,
  <AppstoreOutlined />,
  <MailOutlined />,
  <PieChartOutlined />,
  <DesktopOutlined />,
  <ContainerOutlined />,
  <MenuFoldOutlined />,
  <AppstoreOutlined />,
  <MailOutlined />,
  <PieChartOutlined />,
  <DesktopOutlined />,
  <ContainerOutlined />,
  <MenuFoldOutlined />,
  <AppstoreOutlined />,
  <MailOutlined />,
  <PieChartOutlined />,
  <DesktopOutlined />,
  <ContainerOutlined />,
  <MenuFoldOutlined />,
]

function getItem(
  id: React.Key,
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: 'group',
): MenuItem {
  return {
    key,
    id,
    icon,
    children,
    label,
    type,
  } as MenuItem;
}
export default function Main() {
  const [menuList, setMenuList] = useState<MenuItem[]>([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let defaultSelectedKeys = useSelector((state: RootState) => state.Menu.defaultSelectedKeys);
  let defaultOpenKeys = useSelector((state: RootState) => state.Menu.defaultOpenKeys);
  let collapsed = useSelector((state: RootState) => state.Config.collapsed);
  let [openKeys, setOpenKeys] = useState<string[]>([]);

  const getMenuList = () => {
    Https.post({
      url: 'Api/URPM/V1/menu/list/all',
      data: {
        applicationId: 0
      }
    }).then(res => {
      if(res.state) {
        let list: MenuItem[] = [];
        const menuData = res.data as MenuApiItem[];
        let index = 0;
        for(let item of menuData) {
          if(!item.fatherId) {
            item.children = [];
            item.key = (item.menuCode || item.id) as string;
            item.label = item.menuName;
            list.push(getItem(item.id, item.menuName, item.key, IconList[index], []));
            index ++;
          }
        }
        for(let l of list) {
          for(let item of menuData) {
            item.key = item.menuCode;
            item.label = item.menuName;
            if(l && 'children' in l && (l as any).id === item.fatherId) {
              l.children?.push(getItem(item.id, item.menuName, item.key));
            }
          }
          if(l && 'children' in l && l.children?.length === 0) {
            delete l.children;
          }
        }
        setMenuList(list);
      }
    })
  }
  const getMenuLabelByKey = (key: string[]): string[] => {
    let labels: string[] = [];
    if(menuList.length) {
      for(let k of key.reverse()) {
        for(let item of menuList) {
          if (item?.key === k && item && 'label' in item && item.label) {
            labels.push(item.label as string);
            break;
          } else if (item && 'children' in item && item?.children && item.children.length) {
            for (let child of item.children) {
              if (child?.key === k && child && 'children' in child && child.label) {
                labels.push(child.label as string);
                break;
              }
            }
          }
        }
      }
    }
    return labels;
  }
  const menuSelectHandle: MenuProps['onSelect'] = (info) => {
    const labels = getMenuLabelByKey(info.keyPath);
    dispatch({
      type: 'SET_MENU_SELECTED_KEYS',
      payload: { selectedKeys: info.keyPath, keyPath: labels },
    });
    dispatch({
      type: 'SET_MENU_DEFAULT_SELECTED_KEYS',
      payload: info.keyPath,
    });
    if(info.key !== 'main') {
      navigate(`/main/${info.key}`);
    } else {
      navigate('/main', { replace: true });
    }
  }
  useEffect(() => {
    if (menuList.length > 0 && menuList[0] && 'key' in menuList[0] && menuList[0].key && 'label' in menuList[0] && menuList[0].label && !defaultSelectedKeys.length) {
      dispatch({
        type: 'SET_MENU_DEFAULT_SELECTED_KEYS',
        payload: [menuList[0].key as string],
      });
      dispatch({
        type: 'SET_MENU_DEFAULT_OPEN_KEYS',
        payload: [menuList[0].key as string],
      })
      dispatch({
        type: 'SET_MENU_SELECTED_KEYS',
        payload: { selectedKeys: [menuList[0].label as string], keyPath: [menuList[0].label as string] },
      })
    }
  }, [menuList]);

  useEffect(() => {
    getMenuList();
  }, [])
  return(
    <section className="Main">
      <aside className="menu">
        <p className="plat-title">机器人系统平台</p>
        <section className="menu-list">
          {
            defaultSelectedKeys.length ?
            <Menu
              defaultSelectedKeys={defaultSelectedKeys}
              defaultOpenKeys={defaultOpenKeys}
              openKeys={openKeys}
              mode="inline"
              theme="dark"
              inlineCollapsed={collapsed}
              items={menuList}
              onSelect={menuSelectHandle}
              onOpenChange={(keys) => {setOpenKeys([keys.pop()] as string[])}}
            /> :
            null
          }
        </section>
      </aside>
      <aside className="context">
        <HeadContent />
        <RouteGuide />
        <section className="view-content">
          <Outlet />
        </section>
      </aside>
    </section>
  )
}